/**
 * @class GLPIService
 */
function GLPIService(glpiBackend) {
    let self = this;

    /**
     * Get the GLPI tickets of the Store
     * @param  {int} storeId
     * @return {Array}  GLPI tickets
     */
    self.getGLPITickets = function (storeId) {
        return glpiBackend.getGLPITickets(storeId).then(tickets => {
            return tickets;
        });
    };

    /**
     * Get the GLPI tickets of the Store
     * @param  {int} storeId
     * @return {Array}  GLPI tickets
     */
    self.getGLPIProblems = function (id) {
        return glpiBackend.getGLPIProblems(id).then(problems => {
            return problems;
        });
    };

    self.observe = function (id) {
        return glpiBackend.observe(id).then(res => {
            return res;
        });
    };

    return self;
}

GLPIService.$inject = ['glpiBackend'];

angular.module('app.prospection.store.glpiService', []).factory('glpiService', GLPIService);
